export default {"src":"/_next/static/media/payment-paypal-icon.20257a87.svg","height":32,"width":47};